import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Collapse from '@material-ui/core/Collapse';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';
import Switch from '@material-ui/core/Switch';
import { AddCircle, Refresh, CloudUpload } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import { GetFolios, GetProximo, SetFoliaDesde, GetFoliacionAutomatica, SetFoliacionAutomatica } from 'App/Administracion/Actions';
import { FoliosContext } from "App/Administracion/Folios/store";
import { LayoutContext } from 'App/Layout/store'
import { TareasContext } from 'App/Tareas/store'
import AgregarFolios from './AgregarFolios';
import ObtenerFolios from './ObtenerFolios';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import axios from 'axios';
import _ from 'underscore';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
        tableLayout: "fixed"
    },
    textAlignRight: {
        textAlign: "right"
    },
    row: {
        backgroundColor: theme.palette.action.hover
    },
    disabledRow: {
        backgroundColor: theme.palette.action.selected
    },
    iconHover: {
        marginLeft: "2em",
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

function FilaFolios(props) {
    const { classes, theme } = props;
    const [abierto, setAbierto] = useState(false)
    var resumenFolio = _.reduce((props.folios || []),
        (m, e) => {
            m.TipoDocumento = e.TipoDocumento
            m.Utilizados = (m.Utilizados || 0) + e.Utilizados
            //No Expirado
            if (!(moment(e.Expiracion) < moment() || (moment(e.Expiracion) >= moment() && e.Disponibles <= 0))) {
                m.Disponibles = (m.Disponibles || 0) + e.Disponibles
                m.Expiracion = m.Expiracion && moment(m.Expiracion) < moment(e.Expiracion) ? m.Expiracion : e.Expiracion
                m.Desde = m.Desde && m.Desde < e.Desde ? m.Desde : e.Desde
                m.Hasta = m.Hasta && m.Hasta > e.Hasta ? m.Hasta : e.Hasta
                m.Fecha = m.Fecha && moment(m.Fecha) < moment(e.Fecha) ? m.Fecha : e.Fecha
            }

            return m;
        },
        {}
    )
    return (
        <TableRow>
            <TableCell padding={'none'} colSpan={8}>
                <TableRow onClick={() => { setAbierto(!abierto) }}>
                    <TableCell style={{ width: "100vw" }}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            {resumenFolio.TipoDocumento}
                        </ExpansionPanelSummary>
                    </TableCell>
                    <TableCell style={{ width: "12.5%" }}>{moment(resumenFolio.Fecha).format("L")}</TableCell>
                    <TableCell style={{ width: "12.5%" }}>{moment(resumenFolio.Expiracion).format("L")}</TableCell>
                    <TableCell style={{ width: "10%" }} numeric>{resumenFolio.Desde || ""}</TableCell>
                    <TableCell style={{ width: "10%" }} numeric>{resumenFolio.Hasta || ""}</TableCell>
                    <TableCell style={{ width: "10%" }} numeric>{resumenFolio.Utilizados || ""}</TableCell>
                    <TableCell style={{ width: "10%" }} numeric><b>{resumenFolio.Disponibles || ""}</b></TableCell>
                    <TableCell style={{ width: "10%" }} numeric><b>{((resumenFolio.Disponibles || 0) + (resumenFolio.Utilizados || 0)) || ""}</b></TableCell>
                </TableRow>
                <Collapse hidden={!abierto} in={abierto}>
                    {(props.folios || []).map((folio, ix) => {
                        var disabled = moment(folio.Expiracion) < moment() || (moment(folio.Expiracion) >= moment() && folio.Disponibles <= 0)
                        return (
                            <TableRow className={disabled ? classes.disabledRow : classes.row} key={ix}>
                                <TableCell style={{ width: "100vw" }}>
                                    <ExpansionPanelSummary>
                                        {folio.TipoDocumento}
                                    </ExpansionPanelSummary>
                                </TableCell>
                                <TableCell style={{ width: "12.5%" }}>{moment(folio.Fecha).format("L")}</TableCell>
                                <TableCell style={{ width: "12.5%", color: moment(folio.Expiracion) < moment() ? "red" : "black" }}>{moment(folio.Expiracion).format("L")}</TableCell>
                                <TableCell style={{ width: "10%" }} numeric>{folio.Desde}</TableCell>
                                <TableCell style={{ width: "10%" }} numeric>{folio.Hasta}</TableCell>
                                <TableCell style={{ width: "10%" }} numeric>{folio.Utilizados}</TableCell>
                                <TableCell style={{ width: "10%", color: moment(folio.Expiracion) >= moment() && folio.Disponibles <= 0 ? "red" : "black" }} numeric><b>{folio.Disponibles}</b></TableCell>
                                <TableCell style={{ width: "10%" }} numeric><b>{folio.Hasta - folio.Desde + 1}</b></TableCell>
                            </TableRow>)
                    })}
                </Collapse>
            </TableCell>
        </TableRow>
    );
}

var FilaFoliosT = withStyles(styles, { withTheme: true })(FilaFolios)

function Folios(props) {
    const { classes, theme } = props;
    const foliosContext = useContext(FoliosContext);
    const layoutContext = useContext(LayoutContext);
    const tareasContext = useContext(TareasContext);

    const [folios, setFolios] = useState([]);
    const [proximos, setProximos] = useState([]);
    const [automatico, setAutomatico] = useState([]);
    const [cargando, setCargando] = useState(false);

    function actualizaTabla() {
        GetFolios((f) => {
            setFolios(_.groupBy(f, 'TipoDocumento'))
        })
    }
    function actualizaProximoFolio(callback) {
        GetProximo(f => {
            setProximos(Object.entries(f).map(o => { return { tipo: o[0], folio: o[1], nuevo: o[1] } }));
            if (callback) {
                callback()
            }
        })
    }

    function actualizaFoliacionAutomatica() {
        GetFoliacionAutomatica(f => setAutomatico(f))
    }

    useEffect(() => {
        actualizaTabla();
        actualizaProximoFolio();
        actualizaFoliacionAutomatica();
    }, []);

    useEffect(() => {
        if (_.any(tareasContext.state.ultimoCambio, e => e.estado == "Finalizada" && (e.metodo || "").startsWith("Folios"))) {
            actualizaTabla();
        }
    }, [tareasContext.state.ultimoCambio])

    function ReobtenerFolios() {
        layoutContext.dispatch({
            type: "setAlert", Alert: {
                Accion: () => {
                    axios.post('/api/Administracion/Folio/Reobtener', {}).catch((e) => {
                        console.log(e.response.data.Mensaje);
                    })
                },
                titulo: "Reobtención de Folios",
                contenido: <div>
                    <p>Se obtendrán todos los folios disponibles en el SII. Esto puede tomar unos segundos.</p>
                </div>
            }
        })
    }
    return (
        <div>
            <AgregarFolios />
            <ObtenerFolios />
            <Grid container spacing={24}>
                <Grid item sm={12}>
                    <Typography variant="h5">Folios solicitados</Typography>
                </Grid>
                <Grid item sm={12} className={classes.textAlignRight}>
                    <Tooltip title="Obtener folio">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            foliosContext.dispatch({ type: "toggleObtenerFolio" });
                        }}>
                            <AddCircle />
                        </Icon>
                    </Tooltip>
                    {/* <Tooltip title="Cargar folios">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            foliosContext.dispatch({ type: "toggleAgregarFolio" });
                        }}>
                            <CloudUpload />
                        </Icon>
                    </Tooltip> */}
                    <Tooltip title="Reobtener folios">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            ReobtenerFolios();
                        }}>
                            <Refresh />
                        </Icon>
                    </Tooltip>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.root}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: "25%" }}>Tipo de documento</TableCell>
                                    <TableCell style={{ width: "12.5%" }}>Fecha</TableCell>
                                    <TableCell style={{ width: "12.5%" }} numeric>Expiración</TableCell>
                                    <TableCell style={{ width: "10%" }} numeric>Desde</TableCell>
                                    <TableCell style={{ width: "10%" }} numeric>Hasta</TableCell>
                                    <TableCell style={{ width: "10%" }} numeric><b>Utilizados</b></TableCell>
                                    <TableCell style={{ width: "10%" }} numeric><b>Disponibles</b></TableCell>
                                    <TableCell style={{ width: "10%" }} numeric><b>Total</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Object.entries(folios).map(f => {
                                    return <FilaFoliosT classes folios={f[1]} />
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
                <Grid item sm={12}>
                    <Typography variant="h5">Configuración</Typography>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.root}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell width="15%">
                                        Tipo de Documento
                            </TableCell>
                                    <TableCell width="25%">
                                        Próximo Folio (*)
                            </TableCell>
                                    <TableCell width="50%">
                                        Solicitud Automática de CAF (**)
                            </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Object.keys(folios)
                                        .map((p, i) => {
                                            var auto = automatico.find(o => (_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(o.tipo) }) || {}).Nombre == p);
                                            var proximo = proximos.find(o => (_.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(o.tipo) }) || {}).Nombre == p);
                                            return <TableRow>
                                                <TableCell>
                                                    {cargando === i ? <LinearProgress variant="query" /> : null}
                                                    {p}
                                                </TableCell>
                                                <TableCell>
                                                    {proximo && <FormControl fullWidth>
                                                            <Input
                                                                fullWidth
                                                                type="number"
                                                                value={proximo.nuevo || 0}
                                                                InputLabelProps={{ shrink: true }}
                                                                onChange={e => {
                                                                    proximo.nuevo = parseFloat(e.target.value)
                                                                    setProximos([...proximos])
                                                                }
                                                                }
                                                                variant="outlined"
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="Guardar"
                                                                            disabled={cargando}
                                                                            onClick={() => {
                                                                                if (proximo.nuevo != proximo.folio) {
                                                                                    setCargando(i)
                                                                                    SetFoliaDesde(proximo.tipo, proximo.nuevo, () => {
                                                                                        actualizaProximoFolio(() => setCargando(false))
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            <SaveIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                        </FormControl> }
                                                </TableCell>
                                                <TableCell>
                                                    <Grid container>
                                                        <Grid item sm={2}>
                                                            <Switch
                                                                checked={auto ? true : false}
                                                                onChange={(c, e) => {
                                                                    var tipo = (_.findWhere(layoutContext.state.tiposDoc, { Nombre: p }) || {}).ID
                                                                    if (e) {
                                                                        setAutomatico([...automatico, { tipo, umbral: 0, cantidad: 0 }])
                                                                    } else {
                                                                        if (auto) {
                                                                            setCargando(i)
                                                                            SetFoliacionAutomatica({ eliminar: true, tipo }, () => {
                                                                                setCargando(false)
                                                                            })
                                                                            setAutomatico([...automatico.filter(o => o.tipo != tipo)])
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        {auto &&
                                                            <Grid item sm={5}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel shrink htmlFor="umbral"><small>Cuando los folios disponibles bajen de</small></InputLabel>
                                                                    <Input
                                                                        id="umbral"
                                                                        fullWidth
                                                                        type="number"
                                                                        margin="dense"
                                                                        value={auto.umbral || ""}
                                                                        onChange={e => {
                                                                            auto.umbral = e.target.value > 0 ? e.target.value : auto.umbral
                                                                            setAutomatico([...automatico]);
                                                                        }
                                                                        }
                                                                    />
                                                                </FormControl></Grid>}
                                                        {auto && <Grid item sm={5}><FormControl fullWidth>
                                                            <InputLabel shrink htmlFor="cantidad"><small>Solicitar esta cantidad de folios</small></InputLabel>
                                                            <Input
                                                                id="cantidad"
                                                                type="number"
                                                                fullWidth
                                                                margin="dense"
                                                                value={auto.cantidad || ""}
                                                                onChange={e => {
                                                                    auto.cantidad = e.target.value > 0 ? e.target.value : auto.cantidad
                                                                    setAutomatico([...automatico]);
                                                                }
                                                                }
                                                                variant="outlined"
                                                                endAdornment={
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="Guardar"
                                                                            disabled={cargando}
                                                                            onClick={() => {
                                                                                setCargando(i)
                                                                                var tipo = (_.findWhere(layoutContext.state.tiposDoc, { Nombre: p }) || {}).ID
                                                                                SetFoliacionAutomatica({ tipo, umbral: auto.umbral, cantidad: auto.cantidad }, () => {
                                                                                    setCargando(false)
                                                                                })
                                                                            }}
                                                                        >
                                                                            <SaveIcon />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                            />
                                                        </FormControl></Grid>}
                                                    </Grid>
                                                </TableCell>
                                            </TableRow>
                                        })
                                }
                            </TableBody>
                        </Table>
                        <Grid item sm={12}>
                            <br />
                            <Typography variant="caption">&nbsp;&nbsp;&nbsp;(*) Se muestra el cálculo del próximo folio que el DTE utilizará en base al valor ingresado, y los CAF vigentes.</Typography>
                            <br />
                            <Typography variant="caption">&nbsp;&nbsp;&nbsp;(**) La solicitud automática de CAF se hace cada una hora si los folios disponibles bajan del umbral.</Typography>
                            <br />
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

Folios.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Folios);